import React from 'react';
import PageHeader from './PageHeader';
import PullToRefresh from '../common/PullToRefresh';
import { useRefresh } from '../../hooks/useRefresh';

const PageLayout = ({ 
  title, 
  showBackButton = true, 
  showStatus = false, 
  rightContent = null, 
  onRefresh = null,
  onBack = null,
  children 
}) => {
  const { refreshData } = useRefresh();

  return (
    <div className="flex flex-col h-full w-full bg-white overflow-hidden">
      <div className="shrink-0 z-10">
        <PageHeader 
          title={title}
          showBackButton={showBackButton}
          showStatus={showStatus}
          rightContent={rightContent}
          onBack={onBack}
        />
      </div>
      <main className="flex-1 w-full relative overflow-hidden">
        <PullToRefresh onRefresh={onRefresh || refreshData}>
          <div className="px-4 py-5 w-full min-h-full">
            {children}
          </div>
        </PullToRefresh>
      </main>
    </div>
  );
};

export default PageLayout;